import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeaderComponent implements OnInit {

  email: string;
  pictureUrl: string;

  constructor(private router: Router, public auth: AuthService) {
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      this.refresh();
    });

    this.refresh();
  }

  refresh() {
    this.auth.user$.subscribe(user => {
      this.email = user.email;
      this.pictureUrl = user.picture;
    });
  }

  public getReturnUrl(): string {
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '') + '/logged-out';
  }
}
